export default "__VITE_ASSET__B0l5FW8z__"